export enum InputTypes {
    text = 'text',
    number = 'number',
    amount = "amount",
    email = 'email',
    none = 'none',
    boolean = 'boolean',
    button = 'button',
    file = 'file',
    paymentForm = 'payment form',
    dropdown = 'dropdown',
    calendar = 'calendar',
    cardsSelect = "cardsSelect",
    multipleSelect = "multipleSelect",
    multipleCheckSelect = "multipleCheckSelect",
    phoneNumber = "phoneNumber",
    locationSearch = "locationSearch",
    nested = "nested"
}


// WEBPACK FOOTER //
// ./src/scenes/Forms/components/FormStepper/InputTypes.ts